export default __webpack_public_path__ + "static/media/machine.c035a982.svg";